import type { UserInfoResponse } from '@/chat-types/model/user/UserInfoResponse';
import client from '@/apis/client';
import type { UserListRequestParams } from '@/chat-types/model/user/UserListParams';

export type UserProfileApiResponse = {
  body?: UserInfoResponse;
  result: string;
};

export const userProfileApiById = (id: string) => {
  const formData = new FormData();

  formData.set('userId', id);

  return client.post<UserProfileApiResponse>('/shopl-chat/user/info', formData);
};

export const userProfileApi = () => {
  return client.post<UserProfileApiResponse>('/shopl-chat/user/info');
};

/**
 * @구성원_리스트_with_페이지네이션
 */
export const getUserListInfinity = async (data: UserListRequestParams) => {
  const formData = new FormData();
  formData.set('page', data.page);
  formData.set('records', data.records);
  if (data.searchName) {
    formData.set('searchName', data.searchName);
  }
  if (data.groupList) {
    formData.set('groupList', data.groupList.join(','));
  }
  if (data.positionList) {
    formData.set('positionList', data.positionList.join(','));
  }

  const res = await client.post('/shopl-chat/user/list', formData);
  const { body } = res.data;

  const list = body.content as UserInfoResponse[];
  const nextPage: number = body.pageable.pageNumber + 1;
  const isLast: boolean = body.last;
  const total: number = body.totalElements;

  return {
    data: list || [],
    nextPage,
    isLast,
    total,
  };
};
